import { MutationTree } from 'vuex';
import { LlmState } from './types';

export const mutations: MutationTree<LlmState> = {
  setAnswer(state, payload: string) {
    state.answer = payload;
  },
  setIsLoading(state, payload: boolean) {
    state.isLoading = payload;
  },
};
